<template>
  <div v-if="isLogged" class="side-viewed-vacancies">
    <div class="side-viewed-vacancies__title">{{ $tVacancies('Viewed') }}</div>
    <ul class="side-viewed-vacancies__list">
      <li v-if="pending" class="side-viewed-vacancies__item _preloader">
        <BasePreloader/>
      </li>
      <li class="side-viewed-vacancies__item"
          v-for="item in items"
          :key="item.id"
          :class="item.resume_sended ? '_accent' : null"
      >
        <div class="side-viewed-vacancies__item-inner">
          <router-link-modified :to="{name: 'vacancy', params: {vacancyId: item.slug}}"
                                class="side-viewed-vacancies__link">
            {{ item.title }}
          </router-link-modified>
          <div class="side-viewed-vacancies__param"
               v-if="item.salary_from || item.salary_to">
            {{ item.salary_from | formatCurrency }} - {{ item.salary_to | formatCurrency }}
            {{ currentCurrency.currency }}/{{ $tGlobal(getSalaryTypeById(item.salary_type)) }}
          </div>
          <BaseSvg
              v-if="item.resume_sended"
              class="side-viewed-vacancies__check-ico"
              name="ico-check-round"/>
        </div>
      </li>
    </ul>
    <p v-if="!items.length && !pending">{{ $tVacancies('No viewed vacancies') }}</p>
  </div>
</template>

<script>
  import {http} from "../axios";

  export default {
    name: "SideRecent",
    components: {},
    data() {
      return {
        pending: false,
        items: []
      }
    },
    computed: {
      isLogged() {
        return this.$store.getters['user/isLogged']
      },
      currentCurrency() {
        return this.$store.state.currentCurrency
      },
    },
    methods: {
      load() {
        if (!this.isLogged) return
        this.pending = true

        http.get('/api/vacancies/viewed').then(({data}) => {
          this.items = data.data
        }).finally(() => {
          this.pending = false
        })
      },
      getSalaryTypeById(id) {
        const salaryType = this.$store.state.salaryTypes.find(type => type.id === id)
        return salaryType ? salaryType.shortName : null
      }
    },
    created() {
      this.load()
    }
  }
</script>

<style>

</style>
